import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import concat from 'lodash/fp/concat';
import sortBy from 'lodash/fp/sortBy';
import { handleActions } from 'redux-actions';

export const initialState = {
  weekAvailability: [],
  advancedAvailability: [],
  instantBookInfo: [],
};

const dashboardFreelancer = handleActions(
  {
    SET_DAY_AVAILABILITY: (state, action) => ({
      ...state,
      weekAvailability: [...state.weekAvailability, action.payload.weekDay],
    }),
    UPDATE_DAY_AVAILABILITY: (state, action) => {
      const otherDays = state.weekAvailability.filter(
        week => week.day !== action.payload.weekDay.day,
      );

      return {
        ...state,
        weekAvailability: [...otherDays, action.payload.weekDay],
      };
    },
    SET_WEEK_AVAILABILITY: (state, action) => ({
      ...state,
      weekAvailability: action.payload.weekAvailability,
    }),
    SET_ADVANCED_DAY: (state, action) => {
      const { date, id } = action.payload;

      const pendingDay = state.advancedAvailability.find(d => !d.hours);

      const otherList = flow(items =>
        concat(items, { ...pendingDay, date, id }),
      )(state.advancedAvailability.filter(d => d.hours));

      const advancedAvailability = isEmpty(state.advancedAvailability)
        ? [{ date, id }]
        : otherList;

      return {
        ...state,
        advancedAvailability,
        pendingDay: { ...pendingDay, date, id },
      };
    },
    SET_ADVANCED_CHECKBOX: (state, action) => {
      const { available } = action.payload;

      const others = state.advancedAvailability.filter(d => d.hours) || [];
      const advancedAvailability = [
        ...others,
        { ...state.pendingDay, available },
      ];

      return {
        ...state,
        advancedAvailability,
        pendingDay: { ...state.pendingDay, available },
      };
    },
    SET_ADVANCED_SCHEDULE: (state, action) => {
      const { day } = action.payload;
      const others = state.advancedAvailability.filter(d => d.hours) || [];
      return {
        ...state,
        advancedAvailability: [...others, day],
        pendingDay: null,
      };
    },
    SET_ADVANCED_AVAILABILITY: (state, action) => {
      const { advancedAvailability } = action.payload;

      return {
        ...state,
        advancedAvailability,
      };
    },
    UPDATE_ADVANCED_SCHEDULE: (state, action) => {
      const { day } = action.payload;
      const advancedAvailability = state.advancedAvailability.filter(
        adv => adv.id !== day.id,
      );
      return {
        ...state,
        advancedAvailability: [...advancedAvailability, day],
      };
    },
    SET_INSTANT_BOOK_INFO: (state, action) => {
      const instantBookInfo = flow(sortBy(item => item.id))(
        action.payload.instantBookInfo,
      );

      return {
        ...state,
        instantBookInfo,
      };
    },
    SET_INSTANT_BOOK_ITEM: (state, action) => {
      const { instantBookItem } = action.payload;

      const instantBookInfo = flow(
        filter(item => item.id !== instantBookItem.id),
        items => concat(items, instantBookItem),
        sortBy(item => item.id),
      )(state.instantBookInfo);

      return {
        ...state,
        instantBookInfo,
      };
    },
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default dashboardFreelancer;



// WEBPACK FOOTER //
// ./src/store/reducers/DashboardFreelancer/index.js